import {HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_MOBILE} from "@view/constants/size";

export const sx = {
    root: {
        width: '100%',
        borderRadius: '0',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: {
            xs: HEADER_HEIGHT_MOBILE,
            xl: HEADER_HEIGHT_DESKTOP
        }
    },
    drawer: {
        display: {xs: 'block', lg: 'none'},
        '& .MuiDrawer-paper': {boxSizing: 'border-box', width: 320}
    },
    inner: {
        paddingRight: '5px'
    },
    mobile:{
        closeSidebar:{
            root:{},
            button:{
                width:'45px',
                height:'45px',
            }
        }
    }
}